import * as React from 'react';
import { Translate } from 'react-localize-redux';
import { toast, ToastContainer } from 'react-toastify';
import styled from 'styled-components';
import { check_password, str_has_capital, str_has_lower, str_has_number, str_has_special, str_is_long } from 'validators-web';
import { translateToString } from '../../../styles/global/translate';
import { changePassword } from './action';
import { DarkGreySidely, SurfaceColor } from '../../../styles/global/css/Utils';
import { FormWrapperForm, LOGIN_INPUT_STYLE, LoginLanguagePicker, LoginLogo, LoginText, PageWrapper } from '../login/Login';
import { NoMarginH1 } from '../../authorization/users/Members';
import Input from '../../../components_v2/input/Input';
import { DefaultButton } from '../../../styles/global/css/GlobalButton';
import { ButtonStyle } from '../../../components_v2/popup/PopupCreation';

type loadingState = 'loading' | 'loaded' | 'error'

const PasswordField = styled.div<{ ok: boolean, color?: string; fontSize?: string }>`
    width: fit-content;
    position: relative;
    font-weight: 200;
     ${p => p.color ? `color: ${p.color};` : ''}
    font-size: ${p => p.fontSize || '14px'};
    &:after {
        display: ${p => p.ok ? '' : 'none'};
        content: ' ';
        position: absolute;
        top: 50%;
        left: 0;
        width: 100%;
        height: 1px;
        background: ${p => p.color || SurfaceColor};
        animation-name: ${p => p.ok ? 'strike' : ''};
        animation-duration: 0.25s;
        animation-timing-function: linear;
        animation-iteration-count: 1;
        animation-fill-mode: forwards;
    }
    @keyframes strike{
        0%   { width : 0; }
        100% { width: 100%; }
    }

`;

export default function Reset() {
	const [password, setPassword] = React.useState<string>('');
	const [loadingState, setLoadingState] = React.useState<loadingState>('loaded');
	const disabled = !check_password(password) || loadingState == 'loading';

	const urlSearchParams = new URLSearchParams(window.location.search);
	const params = Object.fromEntries(urlSearchParams.entries());
	if (!params.token) {
		window.location.href = '/login';
	}

	function onSubmit(e: React.FormEvent) {
		e.preventDefault();
		if (disabled) return;
		setLoadingState('loading');
		changePassword(params.token, password)
			.then(_res => {
				setLoadingState('loaded');
				window.location.href = '/login';
			})
			.catch(e => {
				setLoadingState('error');
				console.log(e);
				toast.error(translateToString('login.reset_password_error'), {
					position: 'top-right',
					autoClose: 10000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined
				});
			});
	}

	return <PageWrapper>
		<ToastContainer
			position="top-right"
			autoClose={10000}
			hideProgressBar={false}
			newestOnTop
			closeOnClick
			rtl={false}
			pauseOnFocusLoss
			draggable
			pauseOnHover
		/>
		<FormWrapperForm onSubmit={onSubmit}>
			<LoginLogo />
			<NoMarginH1><Translate id='login.change_password' /></NoMarginH1>
			<LoginText><Translate id='login.choose_password_constraint' /></LoginText>
			<div style={{ width: '320px' }}>
				<PasswordRestriction password={password} color={DarkGreySidely} />
			</div>
			<Input
				name='password'
				type='password'
				label={translateToString('login.password')}
				inputStyle={LOGIN_INPUT_STYLE}
				value={password}
				onChange={value => setPassword(value)}
			/>
			<DefaultButton
				buttonStyle={ButtonStyle.Primary}
				width='320px'
				height='40px'
				disabled={disabled}
			><Translate id='global.fire.confirm_message' /></DefaultButton>
		</FormWrapperForm>
		<LoginLanguagePicker />
	</PageWrapper>;
}

export function PasswordRestriction(props: { password: string, color?: string, fontSize?: string }) {
	return <>
		<PasswordField color={props.color} fontSize={props.fontSize} ok={str_has_capital(props.password)}><Translate id="login.capital_constraint" /></PasswordField>
		<PasswordField color={props.color} fontSize={props.fontSize} ok={str_has_lower(props.password)}><Translate id="login.lower_constraint" /></PasswordField>
		<PasswordField color={props.color} fontSize={props.fontSize} ok={str_has_number(props.password)}><Translate id="login.number_constraint" /></PasswordField>
		<PasswordField color={props.color} fontSize={props.fontSize} ok={str_has_special(props.password)}><Translate id="login.special_constraint" /></PasswordField>
		<PasswordField color={props.color} fontSize={props.fontSize} ok={str_is_long(props.password)}><Translate id="login.length_constraint" /></PasswordField>
	</>;
}
